export default "__VITE_ASSET__dce6c1e0__"